/**
 * Definition / Theorem / Note / Card primitives — small reusable blocks
 * used throughout content pages.
 */

export function Definition({ label = 'Definition', children }) {
  return (
    <div className="def-block">
      <span className="label-pill">{label}</span>
      {children}
    </div>
  );
}

export function Theorem({ label = 'Theorem', children }) {
  return (
    <div className="thm-block">
      <span className="label-pill" style={{ background: 'var(--ink)' }}>{label}</span>
      {children}
    </div>
  );
}

export function Note({ label = 'Note', children }) {
  return (
    <div className="note-block" style={{ background: 'rgba(0,0,0,0.04)' }}>
      <span className="label-pill" style={{ background: 'var(--ink-soft)' }}>{label}</span>
      {children}
    </div>
  );
}

export function Card({ heading, children }) {
  return (
    <div className="bg-paper-warm border border-rule p-4">
      {heading && (
        <h5 className="m-0 mb-2 font-mono text-[10px] uppercase tracking-[0.2em] text-accent">
          {heading}
        </h5>
      )}
      <div className="text-[0.96rem] [&_p]:my-1">{children}</div>
    </div>
  );
}

export function CardGrid({ children }) {
  return (
    <div className="grid gap-4 my-5" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))' }}>
      {children}
    </div>
  );
}
